module.exports = __webpack_public_path__ + "images/drawings/moon/waning-crescent.29816019522cd37e700ca7db352a6ddf.png";